// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vw0z","content":"styles_content__1_lPt"};